import axios from 'axios';
import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { Field, reduxForm } from 'redux-form';
import { RenderSelect } from '../../../component/formInput';

var _ = require('lodash');

const validate = (values) => {
  const errors = {};

  if(!values.new_ip_server) {
    errors.new_ip_server = "Vui lòng chọn IP Server mới";
  } 
  return errors;
}


// Lấy ra loại Server IP cho dịch vụ hosting cần thay đổi cấu hình.
// Nếu dịch vụ hiện tại OS là LINUX thì cần lấy danh sách SERVER thuộc WINDOW và ngược lại.
function getNewServerIpType(productType) {
    switch(productType) {
      case "LINUX_HOSTING" : {
        return "SERVER_PLESK"
      }
      case "WINDOW_HOSTING" : {
        return "SERVER_CPANEL"
      }
    }
  }

class ChangeHostingOS extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      ip_server_data: []
    }
  }

  componentDidMount() {
    this.getIPServerList();
  }

  handleOnHide = () => {
    const { onHide, destroy } = this.props;
    destroy();
    onHide();
  }

  getIPServerList() {
    const {userProduct} = this.props;
    const product_type = userProduct.product.product_type;
    const self = this;

    axios({
      method: 'get',
      url: window.api_url + '/admin/api/ip_server/' + getNewServerIpType(product_type),
      withCredentials: true
    }).then(function (response) {
      if(!response.data.isError) {
        self.setState({
          ip_server_data: response.data.data
        })
      }
    });
  }

  submit = (values) => {
    const { userProduct } = this.props;
    const self = this;
    return axios({
      method: 'post',
      url: window.api_url + '/admin/api/service/hosting_os/modify',
      data: {
        user_product_id: userProduct.id,
        new_ip_server: values.new_ip_server
      },
      withCredentials: true
    }).then(function (response) {
      if (!response.data.isError) {
        toast.success("Thay đổi cấu hình Hosting thành công.")
        self.handleOnHide();
      } else {
        toast.error(response.data.error)
      }
    })
  }

  render() {
    const { title, submitting, userProduct, handleSubmit } = this.props;
    const { ip_server_data } = this.state;
    const modalConfig = { backdrop: 'static', show: this.props.show, bssize: "medium", onHide: this.props.onHide, submitting: this.props.submitting };
    const ip_options = _.map(ip_server_data, (i) => ({label: `${i.ip} ${i.group_name ? i.group_name : ""}`  , value: i.ip }))

    return <div style={{ width: '30%' }}>
      <ToastContainer />
      <Modal {...modalConfig} aria-labelledby="contained-modal-title-lg">
        <Modal.Header className="bg-warning" closeButton>
          <Modal.Title id="contained-modal-title-sm">{title}</Modal.Title>
        </Modal.Header>
          <form onSubmit={handleSubmit(this.submit)}>
            <Modal.Body>
                <div style={{paddingTop:20}}> 
                  <p><strong> Tên Dịch Vụ:  </strong> {userProduct.product && userProduct.product.name}</p>
                  <p><strong> Domain:  </strong> {userProduct  && userProduct.domain}</p>
                  <p><strong> IP Server Hiện Tại:  </strong> {userProduct  && userProduct.server_ip_address}</p>
                  <p><i>*Lưu ý: suspend hosting trên server cũ, khởi tạo hosting trên server mới, sau đó sử dụng tính năng này.</i></p>
                </div>  
                <Field name="new_ip_server" placeholder="Chọn IP Server mới..." options={ip_options} component={RenderSelect}></Field>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-right">
                <a style={{marginRight: 10}} className="btn" onClick={() => this.handleOnHide()}>Đóng</a>
                <button type="submit" className="btn bg-warning" disabled={submitting}>Thay đổi</button>
              </div>
            </Modal.Footer>
          </form>
      </Modal>
    </div>
  }
}

const mapState = state => ({

});

const mapDispatch = dispatch => ({
    
});

export default (connect(mapState, mapDispatch)(
  reduxForm({
    form: 'ChangeHostingOS',
    destroyOnUnmount: true,
    enableReinitialize: true,
    validate
  })(withRouter(ChangeHostingOS))));
